import React from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import HomeIcon from '../HomeIcon';
import LogoIcon from '../LogoIcon';
import MenuIconItem from '../MenuIconItem';
import RewardsButton from '../RewardsButton';
import './Header.css';
import ProfileIcon from '../ProfileIcon';
import HeaderAdminLink from '../../containers/Admin/HeaderAdminLink';
import withSounds from '../../containers/withSounds';
import { ApolloError } from 'apollo-client';
import { WINDCREEK_LEGACY_URL } from '../../utils/constants';
import { toggleCasinoSounds } from 'containers/App/actions';
import { makeSelectCasinoSoundsOn } from 'containers/App/selectors';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import WindCreekIcon from 'components/HeaderIcon/WindCreekIcon';

const propertySites = {
  atmore: {
    title: 'Wind Creek Atmore',
    url: 'https://windcreekatmore.com/'
  },
  aruba: {
    title: 'Wind Creek Aruba',
    url: 'http://www.renaissancearubaresortandcasino.com/default-en.html'
  },
  curacao: {
    title: 'Wind Creek Curacao',
    url:
      'http://www.marriott.com/hotels/travel/curbr-renaissance-curacao-resort-and-casino/'
  },
  montgomery: {
    title: 'Wind Creek Montgomery',
    url: 'https://windcreekmontgomery.com/'
  },
  wetumpka: {
    title: 'Wind Creek Wetumpka',
    url: 'https://windcreekwetumpka.com/'
  },
  washeshu: {
    title: 'Wa She Shu',
    url: 'https://washeshucasino.com/'
  }
};

const NavDropdownWithSounds = withSounds({ mouseEnterSound: true })(
  NavDropdown
);
const MenuItemWithSounds = withSounds({ mouseEnterSound: true })(MenuItem);

//const ProfileURL = '/profile'; // use new ux later
const ProfileURL = `${WINDCREEK_LEGACY_URL}/landing/profile`;

const Header = ({
  data: { user, loading, error },
  toggleCasinoSounds,
  startBackgroundSounds,
  stopBackgroundSounds,
  casinoSoundsOn
}) => {
  return (
    <div className="header">
      <Navbar fixedTop fluid>
        <Navbar.Header>
          <HomeIcon user={user} />
        </Navbar.Header>
        <Nav id="property-sites-menu">
          <NavDropdownWithSounds
            id="property-sites-dropdown"
            title={<LogoIcon />}
            noCaret
          >
            <MenuIconItem {...propertySites.atmore} />
            <MenuIconItem {...propertySites.wetumpka} />
            <MenuIconItem {...propertySites.montgomery} />
            <MenuIconItem {...propertySites.aruba} />
            <MenuIconItem {...propertySites.curacao} />
            <MenuIconItem {...propertySites.washeshu} />
          </NavDropdownWithSounds>
        </Nav>
        <RewardsButton href={`/rewards`} />
        <Nav className="nav-welcome-text">
          {user && (
            <div className="welcome-text">
              Welcome, <a href={ProfileURL}>{user.displayName}</a>
            </div>
          )}
        </Nav>
        <Nav className="profile-icon-container">
          {user && (
            <ProfileIcon
              url={ProfileURL}
              size={34}
              src={user && user.avatarUrl}
              border="border"
            />
          )}
        </Nav>
        <Nav className="icon nav-hamburger-menu">
          <div className="menu">
            <NavDropdownWithSounds
              id="main-menu"
              noCaret
              title=""
              className="hamburger-menu"
            >
              <MenuItemWithSounds href={`${WINDCREEK_LEGACY_URL}/perfectcomp`}>
                <p className="has-icon">
                  <WindCreekIcon className="icon-white icon-size-20" />
                  Store
                </p>
              </MenuItemWithSounds>
              {/*<LinkContainer to="/profile" activeClassName="">
                <MenuItemWithSounds>My Account</MenuItemWithSounds>
              </LinkContainer>*/}
              <MenuItemWithSounds href={ProfileURL}>
                My Account
              </MenuItemWithSounds>
              <LinkContainer to="/rewards" activeClassName="">
                <MenuItemWithSounds>My Rewards</MenuItemWithSounds>
              </LinkContainer>
              <LinkContainer to="/profile/change-password" activeClassName="">
                <MenuItemWithSounds>Change Password</MenuItemWithSounds>
              </LinkContainer>
              <MenuItemWithSounds href={`${WINDCREEK_LEGACY_URL}/auction/list`}>
                Auctions
              </MenuItemWithSounds>
              <MenuItemWithSounds href={`${WINDCREEK_LEGACY_URL}/drawings`}>
                Drawings
              </MenuItemWithSounds>
              <MenuItemWithSounds href={`${WINDCREEK_LEGACY_URL}/promos`}>
                Promos
              </MenuItemWithSounds>
              <MenuItemWithSounds href={`${WINDCREEK_LEGACY_URL}/landing/user`}>
                Members
              </MenuItemWithSounds>
              <MenuItemWithSounds
                href={`${WINDCREEK_LEGACY_URL}/landing/support`}
              >
                Support
              </MenuItemWithSounds>
              <HeaderAdminLink user={user} />
              <MenuItemWithSounds onClick={toggleCasinoSounds}>
                Casino Sound {casinoSoundsOn ? 'Off' : 'On'}
              </MenuItemWithSounds>
              <LinkContainer to="/logout" activeClassName="">
                <MenuItemWithSounds>Sign Out</MenuItemWithSounds>
              </LinkContainer>
            </NavDropdownWithSounds>
          </div>
        </Nav>
      </Navbar>
    </div>
  );
};

Header.propTypes = {
  data: PropTypes.shape({
    user: PropTypes.shape({
      email: PropTypes.string,
      userName: PropTypes.string,
      displayName: PropTypes.string
    }),
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.instanceOf(Error),
      PropTypes.instanceOf(ApolloError)
    ]),
    toggleCasinoSounds: PropTypes.func,
    casinoSoundsOn: PropTypes.bool
  })
};

const mapDispatchToProps = dispatch => ({
  toggleCasinoSounds: () => dispatch(toggleCasinoSounds())
});

const mapStateToProps = createStructuredSelector({
  casinoSoundsOn: makeSelectCasinoSoundsOn()
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js